import { redirect, createFileRoute } from '@tanstack/react-router';

/** The queue is the product a staff account sees (WG-84), so `/w` is it. */
export const Route = createFileRoute('/w/')({
  beforeLoad: () => {
    throw redirect({ to: '/w/queue', search: { view: 'all' } });
  },
});
